<template>
  <div class="container">
    <div class="title">
      <span>最新挂牌</span>
    </div>
    <div class="table-wrapper">
      <table class="data-table">
        <thead>
          <tr>
            <th>标的名称</th>
            <th>交易类型</th>
            <th style="text-align:right">挂牌底价</th>
            <th>挂牌截止时间</th>
            <th>挂牌状态</th>
            <th>所属乡镇</th>
          </tr>
        </thead>
      </table>
      <div class="scroll-container">
        <div class="scroll-content" :style="scrollStyle">
          <table class="data-table scroll-table">
            <tbody>
              <tr v-for="(item, index) in displayData" :key="index">
                <td class="subject-name" :title="item.subjectName">{{ item.subjectName }}</td>
                <td :title="item.transactionType">{{ item.transactionType }}</td>
                <td :title="item.listingPrice" style="text-align:right">{{ item.listingPrice }}</td>
                <td :title="item.listingEndTime">{{ item.listingEndTime || '--' }}</td>
                <td :title="item.status">{{ item.status }}</td>
                <td :title="item.town">{{ item.town }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { latestListingList } from '@/api/agriculture-dashboard'

export default {
  name: 'LatestListing',
  data() {
    return {
      tableData: [],
      scrollOffset: 0,
      scrollTimer: null,
      rowHeight: 38,
      visibleCount: 5,
      scrollSpeed: 50,
    }
  },
  computed: {
    displayData() {
      if (this.tableData.length <= this.visibleCount) {
        return this.tableData
      }
      const duplicated = [...this.tableData, ...this.tableData]
      return duplicated
    },
    scrollStyle() {
      return {
        transform: `translateY(-${this.scrollOffset}px)`,
        transition: 'transform 0.3s linear',
      }
    },
  },
  mounted() {
    this.fetchData()
    // 轮询获取数据
    this.pollingTimer = setInterval(() => {
      this.fetchData()
    }, process.env.VUE_APP_LTIME)
  },
  beforeDestroy() {
    this.stopScroll()
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
    }
  },
  methods: {
    async fetchData() {
      try {
        const res = await latestListingList({})
        if (res.code === 0 && res.data) {
          this.tableData = res.data
          if (this.tableData.length > this.visibleCount) {
            this.startScroll()
          }
        }
      } catch (error) {
        console.error('获取最新挂牌清单失败:', error)
      }
    },
    startScroll() {
      this.stopScroll()
      this.scrollTimer = setInterval(() => {
        this.scrollOffset += 1
        const maxOffset = this.tableData.length * this.rowHeight
        if (this.scrollOffset >= maxOffset) {
          this.scrollOffset = 0
        }
      }, this.scrollSpeed)
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer)
        this.scrollTimer = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}

.title {
  position: relative;
  width: 100%;
  height: 70px;
  border-radius: 7px 7px 0px 0px;
  font-weight: bold;
  font-size: 30px;
  color: #fefefe;
  line-height: 70px;
  padding-left: 22px;

  span {
    position: relative;
    z-index: 9;
  }

  &::after {
    z-index: 8;
    content: '';
    position: absolute;
    left: 0;
    bottom: 5px;
    width: 366px;
    height: 23px;
    background: url('~@/img/agriculture/title_line.png') 100% 100%;
  }
}

.table-wrapper {
  width: 100%;
  padding: 0 14px 17px 0;
}

.scroll-container {
  height: 165px;
  overflow: hidden;
  position: relative;
}

.scroll-content {
  will-change: transform;
}

.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 3px;
  font-size: 17px;
  table-layout: fixed;

  thead {
    tr {
      background: rgba(0, 162, 237, 0.3);
      height: 54px;
    }

    th {
      color: #ffffff;
      font-weight: normal;
      padding: 0 12px;
      text-align: left;
      border: none;
      font-size: 20px;
      line-height: 54px;

      &:nth-child(1) {
        width: 30%;
      }

      &:nth-child(2) {
        width: 12%;
      }

      &:nth-child(3) {
        width: 15%;
      }

      &:nth-child(4) {
        width: 18%;
      }

      &:nth-child(5) {
        width: 12%;
      }

      &:nth-child(6) {
        width: 13%;
      }
    }
  }

  tbody {
    tr {
      background: transparent;
      height: 54px;

      &:nth-child(even) {
        background: rgba(0, 162, 237, 0.1);
      }
    }

    td {
      color: #ffffff;
      padding: 0 12px;
      text-align: left;
      border: none;
      font-size: 17px;
      line-height: 54px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:nth-child(1) {
        width: 30%;
      }

      &:nth-child(2) {
        width: 12%;
      }

      &:nth-child(3) {
        width: 15%;
      }

      &:nth-child(4) {
        width: 18%;
      }

      &:nth-child(5) {
        width: 12%;
      }

      &:nth-child(6) {
        width: 13%;
      }

      &.subject-name {
        max-width: none;
      }
    }
  }
}

.scroll-table {
  border-spacing: 0 3px;
}
</style>
